import { Navigate, useParams } from 'react-router-dom';

import { PermissionsEnum } from '@/auth/interfaces';
import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { useGetSector } from '@/shared/actions/erp/sectors.actions';
import { LoaderComponent } from '@/shared/components/ui';
import { SaveSector } from '../../shared/components/SaveSector';

export type UpdateSectorPageProps = {};

const UpdateSectorPage: React.FC<UpdateSectorPageProps> = () => {
  useCheckPermissions(PermissionsEnum.api_change_sector);
  const returnUrlSectorsPage =
    ROUTER_PATHS.mantenimientoOperaciones.sectoresNav;
  const { id } = useParams();
  const { data, isLoading, isRefetching } = useGetSector(id!);

  if (isLoading || isRefetching) return <LoaderComponent />;
  if (!data?.data?.id_sector) return <Navigate to={returnUrlSectorsPage} />;

  return <SaveSector titlePage="Editar sector" editSector={data.data} />;
};

export default UpdateSectorPage;
